import { defineComponent as o } from "vue";
import l from "./NcButton.mjs";
import i from "./NcIconSvgWrapper.mjs";
import { n as a } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const u = o({
  name: "NcDialogButton",
  components: {
    NcButton: l,
    NcIconSvgWrapper: i
  },
  props: {
    /**
     * The function that will be called when the button is pressed
     * @type {() => void}
     */
    callback: {
      type: Function,
      required: !0
    },
    /**
     * The label of the button
     */
    label: {
      type: String,
      required: !0
    },
    /**
     * Optional inline SVG icon for the button
     */
    icon: {
      type: String,
      required: !1,
      default: void 0
    },
    /**
     * The button type, see NcButton
     * @type {'primary'|'secondary'|'error'|'warning'|'success'}
     */
    type: {
      type: String,
      required: !1,
      default: "secondary",
      validator: (n) => typeof n == "string" && ["primary", "secondary", "error", "warning", "success"].includes(n)
    }
  },
  emits: ["click"],
  setup(n, { emit: e }) {
    return { handleClick: (c) => {
      var r;
      (r = n.callback) == null || r.call(n), e("click", c);
    } };
  }
});
var s = function() {
  var e = this, t = e._self._c;
  return e._self._setupProxy, t("NcButton", { attrs: { "aria-label": e.label, type: e.type }, on: { click: e.handleClick }, scopedSlots: e._u([{ key: "icon", fn: function() {
    return [e._t("icon", function() {
      return [e.icon !== void 0 ? t("NcIconSvgWrapper", { attrs: { svg: e.icon } }) : e._e()];
    })];
  }, proxy: !0 }], null, !0) }, [e._v(" " + e._s(e.label) + " ")]);
}, d = [], f = /* @__PURE__ */ a(
  u,
  s,
  d,
  !1,
  null,
  null,
  null,
  null
);
const g = f.exports;
export {
  g as default
};
